import styled from 'styled-components'
import { fadeOut, loadingloopAnim } from './animations'

export const RectBorder = styled.rect`
  stroke-linecap: round;
  stroke-dasharray: 312.4;
  animation: rectBorderAnim 2s linear both infinite;
  stroke-dashoffset: 0;
  stroke-width: 3px;
  /* @media only screen and (max-width: 374px) {
    stroke-dasharray: 287.8;
    animation: rectBorderAnimS 2s linear both infinite;
  } */
  @keyframes rectBorderAnim {
    0% {
      stroke-dashoffset: 937.2;
    }
    100% {
      stroke-dashoffset: 312.4;
    }
  }
  @keyframes rectBorderAnimS {
    0% {
      stroke-dashoffset: 863.4;
    }
    100% {
      stroke-dashoffset: 287.8;
    }
  }
`

export const StopFooterDiv = styled.div<{
  fadeOut: boolean
  duration: any
  myWidthReverse: any
  myWidth: any
  betTotal: any
  test: any
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 58px;
  width: 315px;
  margin: 25px auto;
  position: absolute;
  animation: ${(p) => (p.fadeOut ? fadeOut : null)};
  will-change: transform;
  cursor: pointer;

  .loading-spinner {
    #infinite,
    #background,
    #nonInfinite {
      stroke-width: 3px;
      stroke-linecap: round;
      text-anchor: middle;
    }
    #background {
      stroke: #32075b;
    }

    #infinite {
      stroke: #ffb000;
      stroke-dasharray: 114.7, 500;
      stroke-dashoffset: 534.7;
      animation: ${loadingloopAnim} 4s linear infinite;
    }

    #nonInfinite {
      stroke: #ffb000;
      stroke-dashoffset: -112;
      transition: all ${(p) => p.duration} linear;

      ${(p) =>
        p.myWidth
          ? `stroke-dasharray:  ${p.myWidthReverse} ${p.myWidth}`
          : p.myWidth === 0
          ? 'stroke-dasharray:  634.7, 0;'
          : 'stroke-dasharray: 0, 634.7;'};

      animation: initAnim;
      animation-duration: ${(p) => p.duration};
      animation-timing-function: linear;

      @keyframes initAnim {
        from {
          stroke-dasharray: 0, 634.7;
        }
        to {
          stroke-dasharray: 0, (634.7 / ${(p) => p.betTotal});
        }
      }
      @-webkit-keyframes initAnim {
        from {
          stroke-dasharray: 0, 634.7;
        }
        to {
          stroke-dasharray: 0, ${(p) => p.test};
        }
      }
    }
    #back {
      opacity: 0;
    }
    #text {
      transform: translateX(158px);
    }
  }

  svg {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  #text {
    font-size: 20px;
    transform: translateX(156px);
  }
  #bet {
    font-size: 12px;
    position: absolute;
    right: 50%;
    transform: translateX(50%) translateY(10px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffb000;
    svg {
      margin-left: 4px;
      /* margin-bottom: -1px; */
      width: 11px;
      height: 11px;
      path {
        fill: #ffb000;
      }
    }
  }
`

/* stroke-dasharray: 0, (634.7 / ${(p) => p.betTotal}); */

/* animation: ${(props) => (props.stopA ? btnBackground : null)}; */
/* animation-duration: 0.5s; */
